import axios from "axios";
import api from "./api";

export const changePasswordOtp = async (email) => {
    await api.post(`/api/send-changepasswordOtp?userName=${email}`, {
        headers: { "Content-Type": "application/json" },
    })
}

export const verifyOtpChangePass = async (email, otp) => {
    try {
        // Ensure payload includes both email and OTP
        await api.post(`/api/verify-otp`, {
            userName: email,
            otp
        }, {
            headers: { "Content-Type": "application/json" }
        });
    } catch (error) {
        console.error("Error verifying OTP: ", error); // Log for debugging
        throw new Error("OTP verification failed");
    }
};

export const changePasswordSubmit = async (payload) => {
  try {
    const response = await api.post(`/api/change-password`, payload);
    return response.data;
  } catch (error) {
    // Rethrow full axios error, not just Error object
    throw error;
  }
};

